<!--
 * @Author: mqlpcthree mql_pcthree@163.com
 * @Date: 2024-07-26 09:04:30
 * @LastEditors: mqlpcthree mql_pcthree@163.com
 * @LastEditTime: 2024-09-20 08:47:50
 * @FilePath: \mei_qi_zeroweb_endlyq\src\components\core\MqlLayout\MqlMain\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="mql-main" :class="{ border: border }"><slot></slot></div>
</template>

<script>
export default {
  name: "MqlMain",
  components: {},
  props: {
    border: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.mql-main {
  margin: 15px 20px;
  padding: 10px;
  &.border {
    border: 1px solid #eee;
  }
  .el-input {
    .el-input__inner {
      height: 26px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/core/MqlLayout/MqlMain/index.vue